import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Width in px (default 280). Use "100%" for full width. */
  width?: number | string;
  size?: "small" | "medium";
}

/**
 * Standard rounded search input with a leading icon. Controlled.
 */
export default function SearchBox({
  value,
  onChange,
  placeholder = "Search…",
  width = 280,
  size = "small",
}: SearchBoxProps) {
  return (
    <TextField
      size={size}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      sx={{ width, "& .MuiOutlinedInput-root": { borderRadius: "10px", bgcolor: "background.paper" } }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
